export default "/bell.svg";